import { Outlet } from "react-router-dom";
import { Sidebar } from "../components/Sidebar";

/**
 * Authenticated app shell: hover-revealed navigation rail + routed content area.
 * Design tokens (`--color-*`) are defined statically in `styles/main.scss`
 * (backed by the oasis palette), so no runtime theme injection is needed.
 * Rendered as the layout route for every protected page.
 *
 * The rail owns its own reveal behaviour and expands in layout flow, so the
 * content area animates its width alongside it (mirroring the medonc shell).
 * Notification pages provide their own table scroll region; other routed pages
 * continue to use the shell's content overflow.
 *
 * @returns The sidebar + `<Outlet />` layout
 */
export function HomeShell() {
  return (
    <div className="home-shell main-container flex h-screen w-full">
      <Sidebar />
      <div className="home-shell__outlet min-h-0 min-w-0 flex-1 overflow-auto transition-all duration-300 ease-in-out">
        <Outlet />
      </div>
    </div>
  );
}
